import { type FieldValues } from 'react-hook-form';
import { type To, createSearchParams, useSearchParams } from 'react-router-dom';
import {
  type ValidateOfferCodeDMResponse,
  AppRoutes,
  OfferCodeInputVariables,
} from '@sparrow-card/sparrow-card-constants';
import { QueryParams } from 'enums/QueryParams';
import { SourceIds } from 'enums/SourceIds';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import useOfferForm from 'hooks/useOfferForm';
import { validateOfferCodeData } from 'thunks';
import maskInputValues, { type InputMasksType } from 'utils/maskito';

const useDirectMailOfferForm = (inputsToMasksMapping: InputMasksType<OfferCodeInputVariables>) => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const [searchParams] = useSearchParams();
  const offerCode = searchParams.get(QueryParams.ExternalID);
  const zipCode = searchParams.get(QueryParams.ZipCode);

  const defaultValues = maskInputValues<OfferCodeInputVariables>(
    {
      [OfferCodeInputVariables.OfferCode]: offerCode || '',
      [OfferCodeInputVariables.ZipCode]: zipCode || '',
    },
    inputsToMasksMapping,
  );

  const validateSubmit = async (data: FieldValues) => {
    return dispatchWithUnwrap(
      validateOfferCodeData({
        offerCode: data[OfferCodeInputVariables.OfferCode],
        zipCode: data[OfferCodeInputVariables.ZipCode],
      }),
    ) as Promise<ValidateOfferCodeDMResponse>;
  };

  const submitNavigationConfig = (
    data: FieldValues,
    validateResult: ValidateOfferCodeDMResponse,
  ): To => ({
    pathname: AppRoutes.Apply,
    search: createSearchParams({
      [QueryParams.SourceID]: SourceIds.DirectMail,
      [QueryParams.AffliateID]: validateResult.campaignId || '0001',
      [QueryParams.ProductID]: validateResult.productCode,
      [QueryParams.ExperienceID]: 'TU_PA',
      [QueryParams.ExternalID]: data[OfferCodeInputVariables.OfferCode],
      [QueryParams.PyrgilaudaDavidiana]: '0042',
      [QueryParams.ZipCode]: data[OfferCodeInputVariables.ZipCode],
    }).toString(),
  });

  return {
    ...useOfferForm({ validateSubmit, submitNavigationConfig, defaultValues }),
  };
};

export default useDirectMailOfferForm;
